import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=2c59ef15&scoped=true&"
import script from "./change-password.vue?vue&type=script&lang=ts&"
export * from "./change-password.vue?vue&type=script&lang=ts&"
import style0 from "./change-password.vue?vue&type=style&index=0&id=2c59ef15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c59ef15",
  null
  
)

component.options.__file = "change-password.vue"
export default component.exports